export class GitProvidersBranch {
    constructor(model) {
        this.name = model.name;
        this.lastCommitId = model.lastCommitId;
    }
}
export class GitProvidersBranches {
    constructor(model) {
        this.branches = model.branches.map((branch) => new GitProvidersBranch(branch));
    }
}
